/**
 * The id of the Livewire component an element belongs to - also when the
 * element was teleported out of it.
 *
 * A plain `closest('[wire\\:id]')` cannot answer this: `x-teleport` moves markup
 * to the body, and from there no ancestor carries the attribute any more. Alpine
 * leaves `_x_teleportBack` on what it moved and its own `findClosest()` follows
 * that link, which is exactly how Livewire's `$wire` magic keeps working inside a
 * teleport - so the same walk is used here instead of a second, weaker one.
 *
 * @param {Element|null|undefined} element
 * @returns {string|null}
 */
export default function livewireComponentId(element) {
  if (!element) return null

  const walk = window.Alpine?.findClosest

  const host = typeof walk === 'function'
    ? walk(element, node => node?.hasAttribute?.('wire:id'))
    : element.closest?.('[wire\\:id]')

  return host ? host.getAttribute('wire:id') : null
}
